(function () {
  'use strict';

  if (!window.__mnpqSuppressKlaviyo) return;

  var klaviyoSelector = [
    '[data-testid*="klaviyo"]',
    '[class*="kl-private-reset-css"]',
    '[class*="klaviyo-form"]',
    'iframe[src*="klaviyo"]'
  ].join(',');

  function hideElement(element) {
    var dialog = element.closest('[role="dialog"]');
    var target = dialog || element;

    target.setAttribute('aria-hidden', 'true');
    target.style.setProperty('display', 'none', 'important');
    target.style.setProperty('visibility', 'hidden', 'important');
    target.style.setProperty('pointer-events', 'none', 'important');

    if ('inert' in target) target.inert = true;
  }

  function restoreQuizScroll() {
    document.documentElement.style.removeProperty('overflow');
    if (document.body) document.body.style.removeProperty('overflow');
  }

  function suppressKlaviyo(root) {
    var matches = [];

    if (root.nodeType === 1 && root.matches(klaviyoSelector)) matches.push(root);
    if (root.querySelectorAll) {
      Array.prototype.push.apply(matches, root.querySelectorAll(klaviyoSelector));
    }

    if (!matches.length) return;

    matches.forEach(hideElement);
    restoreQuizScroll();
  }

  suppressKlaviyo(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes, function (node) {
        if (node.nodeType === 1) suppressKlaviyo(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail || {};
    if (detail.type !== 'open' && detail.type !== 'embedOpen') return;

    suppressKlaviyo(document);
    window.requestAnimationFrame(function () {
      suppressKlaviyo(document);
      restoreQuizScroll();
    });
  });
}());
